
import * as serviceWorker from "./serviceWorker";

import configApp, { getConfig } from "./resources/configSettings";
import configAuthBackend from "./resources/Authentication/AuthBackend";
import Demo from "./components/Services/Demo";
import Lisenced from "./components/Services/Lisenced";
import { defineCustomElements } from '@ionic/pwa-elements/loader';

if (process.env.NODE_ENV === 'production') {
    // disable console.log in production mode
    console.log = function () {};
}

configAuthBackend();
configApp();

let config = getConfig();
// console.log(config);

// persistent IndexDB
if (navigator.storage && navigator.storage.persist)
    navigator.storage.persist().then(function (persistent) {
        if (persistent)
            console.log("Storage will not be cleared except by explicit user action");
        else
            console.log("Storage may be cleared by the UA under storage pressure.");
    });


// fetch IP addresss
fetch("/api/serial")
    .then(res => res.json())
    .then(data => {
        if (!localStorage.getItem("ipno")) {
            console.log("ipno not exist");
            localStorage.setItem("ipno", btoa(data.ip));
        }
        console.log('Ip Exist');
    });

if (config.productType === 'demo') {
    Demo()
} else if (config.productType === 'lisensed') {
    Lisenced()
}

defineCustomElements(window);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();

